import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Modal } from "antd";
import GanttChart from "./GanttChart";
import { generateProjectGantChart } from "../../utils/chartCalculations";
const GanttChartModal = ({ isModalOpen, handleOk, handleCancel, modalContent, title, objMaster }) => {
    const dataSource = generateProjectGantChart(objMaster);
    return (_jsxs(Modal, { title: title, open: isModalOpen, onOk: handleOk, onCancel: handleCancel, width: 800, children: [_jsx("div", { className: "project-status", style: {
                    display: 'flex', rowGap: '10px', columnGap: '20px',
                    flexWrap: 'wrap', justifyContent: 'space-around'
                }, children: modalContent === null || modalContent === void 0 ? void 0 : modalContent.map((item, index) => {
                    return (_jsxs("span", { style: { color: `${item === null || item === void 0 ? void 0 : item.strShortDesc}`, fontSize: '11px' }, children: [item === null || item === void 0 ? void 0 : item.strLongDesc, "(", item === null || item === void 0 ? void 0 : item.intStatusCount, ")"] }, index));
                }) }), _jsx(GanttChart, { dataSource: dataSource })] }));
};
export default GanttChartModal;
